import React, { Fragment } from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import HelpLink from '../../../components/library/common/HelpLink';
import OfficesLastUpdated from './OfficesLastUpdated';

const OfficesPageSummary = ({ officeId, officeDetails }) => {
    
    return (
        <Fragment>
            <div className='columns'>
                <div className='column is-8 is-offset-1 homePageHeader' >
                    <h3 className='page-title'>
                        <HrbTranslate text='OfficesPage.Labels.SummaryTitle' />
                    </h3>
                </div>
                <div className='column is-2'>
                    <HelpLink helpKey='0ProSupport/VDOPro/DMDoC_OfficeView.htm' isRight />
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1 homePageHeader' >
                        <Fragment>
                        <HrbTranslate text='OfficesPage.Labels.SummaryHeader' />
                        </Fragment>
                </div>                
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1 homePageHeader' >
                    <OfficesLastUpdated />
                </div>
            </div>           
        </Fragment>
    )
}

OfficesPageSummary.propTypes = {
    officeId: PropTypes.number,
    officeDetails: PropTypes.object
}

export default OfficesPageSummary